export const NAME_FILTER = 'NAME';
export const SUB_TYPE_FILTER = 'SUB_TYPE';
export const TYPE_FILTER = 'TYPE';
export const ACTIVITY_FILTER = 'ACTIVITY';